import $ from 'jquery';
import { getState, modifyState } from '~src/state';

export const zoomIn = () => {
  const canvasZoom = getState('currentCanvasZoom');
  const newCanvasZoom = canvasZoom * 1.15;
  modifyState('currentCanvasZoom', newCanvasZoom);

  // Get parent and child elements
  const parent = $('#canvas-container')[0];
  const child = $('#canvas-zoom')[0];

  // Get dimensions
  const parentHeight = parent.offsetHeight;
  const parentWidth = parent.offsetWidth;
  const childHeight = child.offsetHeight;
  const childWidth = child.offsetWidth;

  // Calculate dynamic margins (centered)
  const marginTop =
    Math.abs((parentHeight - childHeight * newCanvasZoom) / 2) * 2.2;

  // Only apply margin-left if scaled canvas width exceeds container width
  const scaledWidth = childWidth * newCanvasZoom;
  const marginLeft =
    scaledWidth > parentWidth
      ? Math.abs((parentWidth - childWidth * newCanvasZoom) / 2) * 2.2
      : 0;

  $('#canvas-zoom').css({
    transform: `scale(${newCanvasZoom})`,
    'margin-top': marginTop + 'px',
    'margin-left': marginLeft + 'px',
  });

  // Update spell check control sizes for all textboxes
  if (window.canvas) {
    window.canvas.getObjects().forEach((obj) => {
      if (obj.type === 'textbox' && obj.updateControlSizes) {
        obj.updateControlSizes();
      }
    });
  }
};
